import { useSelector } from 'react-redux';
import { getStaticAssetUrl } from '../../helper/getStaticAssetUrl';
import mixpanel from 'mixpanel-browser';

const sessionOptions = getStaticAssetUrl('onboarding-video-title.png');

export const WelcomeVideoTitle = ({ setVideoTitle, videoTitle }) => {
  const userId = useSelector((st) => st.auth?.user?.userId);

  return (
    <div className="flex flex-col max-w-full min-w-0 flex-1">
      <img src={sessionOptions} alt="" className="object-contain" />
      <div className="flex flex-col font-roboto text-black h-[150px] tall:h-[339px] bg-purple bg-opacity-[5%] justify-center items-center w-full rounded-[9px]">
        <span className="text-lg font-bold w-3/5 ml-1.5">
          Enter Your First Video Title
        </span>
        <input
          value={videoTitle}
          onChange={(e) => {
            setVideoTitle(e.target.value);
          }}
          maxLength={90}
          className="outline-none text-base p-3.5 border border-[#EBEBEB] bg-white rounded-[9px] w-3/5 placeholder:text-[#C4C4C4]"
          onBlur={() => {
            mixpanel.track('Onboarding: Default Video Title Changed', {
              distinct_id: userId,
            });
          }}
          placeholder="Enter your video title here..."
        />
      </div>
    </div>
  );
};
